import Vue from 'vue';

// When the request succeeds
const successLookup = (cbInfo, response) => {
  // console.log('pin reset OK response:');
  // console.log(response);
  if (cbInfo && cbInfo.cbSuccess) {
    cbInfo.cbSuccess(response);
  }
};

// When the request fails
const failedLookup = (cbInfo, response) => {
  // console.log('pin reset error response:');
  // console.log(response);
  if (cbInfo && cbInfo.cbFail) {
    cbInfo.cbFail(response);
  }
};

export default (spid, profileName, cbInfo) => {
  const axiosOptions = {
    timeout: 15000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const queryinfo = {
    profile_id: profileName,
  };
  const thisurl = `/api/v1/sp/${spid}/profile/pin-reset`;
  Vue.$http.post(thisurl, queryinfo, axiosOptions)
   .then((response) => {
     successLookup(cbInfo, response);
   })
   .catch((error) => {
     failedLookup(cbInfo, error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/profile/resetpin.js